
export class ArrayUtils {

	public static Contains(arr: any[], value: any): boolean {

		return arr.some((elem) => elem == value);
	}

}
